import keyMirror from 'key-mirror';

export default keyMirror({
  CONFIRM_ALERT: null,
  ADMIN: null,
  CARE_AUTHOR: null,
  CARE_NAVIGATOR: null,
  PATIENT: null,
  PATIENTPROGRESS: null
});
